sessionStorage.clear()
